module.exports = "<footer class=\"app-footer\">\r\n  <span class=\"ml-auto\">Agencia para la Calidad Científica y Universitaria de Andalucía - ACCUA</span>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/app-footer/app-footer.component.html
// module id = ../../../../../src/app/components/app-footer/app-footer.component.html
// module chunks = main